var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonProfit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4998 12.5719L11.9998 19.9999L4.49981 12.5719C4.00512 12.0905 3.61546 11.5119 3.35536 10.8726C3.09527 10.2332 2.97037 9.54688 2.98855 8.85687C3.00673 8.16685 3.16758 7.48807 3.46097 6.86327C3.75436 6.23847 4.17395 5.68119 4.6933 5.22651C5.21265 4.77184 5.82052 4.42962 6.47862 4.22141C7.13673 4.01321 7.83082 3.94352 8.51718 4.01673C9.20354 4.08995 9.86731 4.30449 10.4667 4.64684C11.0661 4.98919 11.5881 5.45193 11.9998 6.00593C12.4133 5.45595 12.9359 4.99725 13.5349 4.65854C14.1339 4.31982 14.7963 4.10838 15.4807 4.03745C16.1652 3.96652 16.8569 4.03763 17.5126 4.24632C18.1683 4.45502 18.7738 4.79681 19.2914 5.2503C19.8089 5.70379 20.2272 6.25922 20.5202 6.88182C20.8132 7.50443 20.9746 8.18082 20.9941 8.86864C21.0137 9.55647 20.8911 10.2409 20.6339 10.8792C20.3768 11.5174 19.9907 12.0958 19.4998 12.5779",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 6L8.70685 9.293C8.51938 9.48053 8.41406 9.73484 8.41406 10C8.41406 10.2652 8.51938 10.5195 8.70685 10.707L9.24985 11.25C9.93985 11.94 11.0598 11.94 11.7498 11.25L12.7498 10.25C13.3466 9.65327 14.1559 9.31803 14.9998 9.31803C15.8438 9.31803 16.6531 9.65327 17.2498 10.25L19.4998 12.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.5L14.5 17.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13L17 15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_3013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonProfit);
export default __webpack_public_path__ + "static/media/non-profit.6deaefef5ed3a68a0e4091d8ae969b2a.svg";
export { ForwardRef as ReactComponent };